"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchParam = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
function getObject(params) {
    const obj = {};
    params.forEach((value, key) => {
        obj[key] = value;
    });
    return obj;
}
function useSearchParam(defaultValue) {
    const history = react_router_dom_1.useHistory();
    const location = react_router_dom_1.useLocation();
    const searchParams = react_1.useMemo(() => {
        var _a;
        const params = new URLSearchParams(location.search);
        for (const key in defaultValue) {
            const value = defaultValue[key];
            params.set(key, (_a = params.get(key)) !== null && _a !== void 0 ? _a : value);
        }
        return params;
    }, [location, defaultValue]);
    const setSearchParams = (newSearchParams) => {
        const oldSearchParams = getObject(searchParams);
        const url = new URLSearchParams({ ...oldSearchParams, ...newSearchParams });
        history.replace(location.pathname + '?' + url.toString());
    };
    return [searchParams, setSearchParams];
}
exports.useSearchParam = useSearchParam;
//# sourceMappingURL=useSearchParam.js.map